import Repository from '../../../Repository';
import { computed } from 'vue';
import store from '@/store';

const company = computed(() => store.getters['company/info']);

export default {
	list(params) {
		return Repository.get(`/company/${company.value.id}/leader/group/list`, { params: params });
	}
}